import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import InputWrapper from '../common/InputWrapper';
import Button from '../common/Button';

import { fetchGetOrganizationSettings } from '../../actions/settings';
import { showModal } from '../../actions/modal';

import { getCurrencyName } from '../../helpers';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const CommonBlock = (props) => {
  const {
    accountSettings,
    checkoutSettings: { commercialAccountRequested, country, currency },
    organizationSettings,
  } = props;

  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.settings);

  const { t } = useAutoTranslation();

  const {
    commercialAccount,
    ofertaAccepted,
    ofertaAcceptPaymentReceived,
    ofertaPaymentBill,
    showOferta,
    merlionClientNumber = null,
  } = accountSettings;

  const handleAddCompany = () => {
    dispatch(
      showModal('EditUserCompany', {
        commercialAccountRequested,
        organizationSettings,
        submitCallback: () => {
          dispatch(fetchGetOrganizationSettings());
        },
        ofertaAccepted,
      }),
    );
  };

  const handleDisplayOfertaInfoBlock = () => {
    let block = null;

    if (ofertaAccepted && !ofertaAcceptPaymentReceived) {
      block = (
        <Fragment>
          <div className="row" style={{ marginTop: '10px' }}>
            <div className="col-12">
              <div className="alert alert-warning" role="alert">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fe-alert-circle mr-2" style={{ fontSize: '20px' }} />
                  <span>
                    <span>
                      {t('Аккаунт не активирован: ожидание поступления платежа-акцепта')}.
                    </span>
                    <br />
                    <span>
                      {t(
                        'До момента активации аккаунт работает в демо-режиме, часть функционала может быть не доступна',
                      )}
                      .
                    </span>
                    <br />
                    {ofertaPaymentBill && (
                      <a href={ofertaPaymentBill} target="_blank" rel="noopener noreferrer">
                        {t('Скачать реквизиты платежа-акцепта')}
                      </a>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    } else if (
      (!commercialAccount && !ofertaAccepted && !ofertaAcceptPaymentReceived) ||
      showOferta
    ) {
      block = (
        <Fragment>
          <div className="row" style={{ marginTop: '10px' }}>
            <div className="col-12">
              <div className="alert alert-warning" role="alert">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fe-alert-circle mr-2" style={{ fontSize: '20px' }} />
                  <span>
                    {t('Учетная запись не активирована')}.{' '}
                    {t('Часть функционала не будет доступна')}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <Button
                className="mt-2 ml-2"
                text={t('Активировать аккаунт')}
                onClick={handleAddCompany}
              />
            </div>
          </div>
        </Fragment>
      );
    }
    return block;
  };

  return (
    <Fragment>
      <div className="border-bottom">
        <h4 className="header-title">{t('Общие настройки')}</h4>
      </div>

      <div className="row" style={{ marginTop: '16px' }}>
        <div className="col-6">
          <div className="form-group">
            <InputWrapper label={t('Аккаунт')} value={accountSettings.login} readOnly />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <InputWrapper label={t('ID аккаунта')} value={accountSettings.shopId} readOnly />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <InputWrapper
              label={t('Страна')}
              value={(countries.find((c) => c.code === country) || { rusName: country }).rusName}
              readOnly
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <InputWrapper label={t('Валюта аккаунта')} value={getCurrencyName(currency)} readOnly />
          </div>
        </div>
      </div>

      {handleDisplayOfertaInfoBlock()}

      {commercialAccount && organizationSettings && organizationSettings.fullName && (
        <div className="row mt-2">
          <div className="col-6">
            <div className="block-subtitle">{t('Юридическое лицо')}</div>
            <div>{organizationSettings.fullName}</div>
            <div className="block-subtitle mt-2">{t('Контакты')}</div>
            {organizationSettings.phones ? <div>{organizationSettings.phones}</div> : null}
            {organizationSettings.email ? <div>{organizationSettings.email}</div> : null}
          </div>
          <div className="col-6">
            <div className="block-subtitle">{t('ОГРН')}</div>
            <div>{organizationSettings.ogrn}</div>
            <div className="block-subtitle mt-2">{t('ИНН / КПП')}</div>
            <div>
              {organizationSettings.inn}
              {organizationSettings.kpp ? `/ ${organizationSettings.kpp}` : null}
            </div>
          </div>
        </div>
      )}
      {merlionClientNumber ? (
        <div className="row mt-1">
          <div className="col-6">
            <div className="block-subtitle">{t('Номер клиента Мерлион')}</div>
            <InputWrapper value={merlionClientNumber} readOnly />
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default CommonBlock;
